// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import * as React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
};

const SvgComponent = (props: SvgProps) => (
    <svg
        width={props.width ?? '130'}
        height={props.height ?? '92'}
        viewBox='0 0 130 92'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        {...props}
    >
        <g clipPath='url(#clip0_4210_88396)'>
            <path
                d='M2.50001 6.00001L2.5 21L127.5 21L127.5 65L66 65'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.24'
                strokeLinecap='round'
            />
            <path
                d='M2.49999 59L2.49999 32L29 32'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.24'
                strokeLinecap='round'
            />
            <path
                d='M18.5 60.5L18.5 46.5L106 46.5'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.24'
                strokeLinecap='round'
            />
            <circle
                cx='2.5'
                cy='2.5'
                r='2.5'
                transform='matrix(1 8.74228e-08 8.74228e-08 -1 0 6)'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <circle
                cx='2.5'
                cy='2.5'
                r='2.5'
                transform='matrix(1 8.74228e-08 8.74228e-08 -1 0 64)'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <circle
                cx='2.5'
                cy='2.5'
                r='2.5'
                transform='matrix(1 8.74228e-08 8.74228e-08 -1 16 64)'
                fill='var(--center-channel-color)'
                fillOpacity='0.4'
            />
            <circle
                cx='71'
                cy='49'
                r='43'
                fill='var(--center-channel-color)'
                fillOpacity='0.12'
            />
            <path
                d='M109.748 82.5258L117.999 91V47C117.999 45.8954 117.104 45 115.999 45H74.9998C73.8952 45 72.9998 45.8954 72.9998 47V79.9211C72.9998 81.0256 73.8952 81.9211 74.9998 81.9211H108.315C108.855 81.9211 109.371 82.1391 109.748 82.5258Z'
                fill='#28427B'
            />
            <circle
                opacity='0.48'
                cx='85.8309'
                cy='56.831'
                r='5.83099'
                fill='#FFFFFF'
            />
            <path
                opacity='0.4'
                d='M94.9999 55H111'
                stroke='#FFFFFF'
                strokeLinecap='round'
            />
            <path
                opacity='0.4'
                d='M80.9999 70H102.38'
                stroke='#FFFFFF'
                strokeLinecap='round'
            />
            <path
                opacity='0.4'
                d='M80.9999 74H95.2535'
                stroke='#FFFFFF'
                strokeLinecap='round'
            />
            <path
                opacity='0.4'
                d='M94.9999 59H109'
                stroke='#FFFFFF'
                strokeLinecap='round'
            />
            <path
                opacity='0.4'
                d='M80.9999 66H92.014'
                stroke='#FFFFFF'
                strokeLinecap='round'
            />
            <path
                opacity='0.4'
                d='M94.6064 66H106.268'
                stroke='#FFFFFF'
                strokeLinecap='round'
            />
            <path
                d='M28.605 57.5638L15 71V2C15 0.895431 15.8954 0 17 0H83C84.1046 0 85 0.89543 85 2V54.9868C85 56.0914 84.1046 56.9868 83 56.9868H30.0103C29.4842 56.9868 28.9793 57.1941 28.605 57.5638Z'
                fill='var(--center-channel-bg)'
            />
            <path
                d='M28.2536 57.2081L15.5 69.8035V2C15.5 1.17157 16.1716 0.5 17 0.5H83C83.8284 0.5 84.5 1.17157 84.5 2V54.9868C84.5 55.8153 83.8284 56.4868 83 56.4868H30.0103C29.3527 56.4868 28.7215 56.746 28.2536 57.2081Z'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
            />
            <circle
                cx='33'
                cy='19'
                r='9'
                fill='var(--center-channel-color)'
                fillOpacity='0.4'
            />
            <path
                d='M48 15H64'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.4'
                strokeLinecap='round'
            />
            <path
                d='M25 39H69'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.4'
                strokeLinecap='round'
            />
            <path
                d='M25 45H47'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.4'
                strokeLinecap='round'
            />
            <path
                d='M48 21H73'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.4'
                strokeLinecap='round'
            />
            <path
                d='M25 33H42'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.4'
                strokeLinecap='round'
            />
            <path
                d='M46 33H64'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.4'
                strokeLinecap='round'
            />
            <circle
                cx='44'
                cy='65'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <circle
                cx='52'
                cy='65'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <circle
                cx='60'
                cy='65'
                r='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <path
                d='M101 33L83 33'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M79 33L73 33'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M70 33L68 33'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.8'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_4210_88396'>
                <rect
                    width='130'
                    height='92'
                    fill='white'
                />
            </clipPath>
        </defs>
    </svg>
);

export default SvgComponent;
